import { produce } from "immer";
import {
  FETCH_CARE_PLAN_TASKS,
  FETCH_CARE_PLAN_TASKS_SUCCESS,
  FETCH_CARE_PLAN_TASKS_FAILURE,
  ADD_CARE_PLAN_TASK,
  ADD_CARE_PLAN_TASK_SUCCESS,
  ADD_CARE_PLAN_TASK_FAILURE,
  EDIT_CARE_PLAN_TASK,
  EDIT_CARE_PLAN_TASK_SUCCESS,
  EDIT_CARE_PLAN_TASK_FAILURE,
  DELETE_CARE_PLAN_TASK,
  DELETE_CARE_PLAN_TASK_SUCCESS,
  DELETE_CARE_PLAN_TASK_FAILURE,
  FETCH_CARE_PLAN_TASK_TEMPLATES,
  FETCH_CARE_PLAN_TASK_TEMPLATES_SUCCESS,
  FETCH_CARE_PLAN_TASK_TEMPLATES_FAILURE,
  MARK_CARE_PLAN_TASK_STATUS,
  MARK_CARE_PLAN_TASK_STATUS_SUCCESS,
  MARK_CARE_PLAN_TASK_STATUS_FAILURE,
} from "./constants";

export const initialState = {
  tasks: {},
  taskTemplates: [],
  isFetchingTasks: false,
  isFetchingTaskTemplates: false,
  isSubmitting: false,
  isDeleting: false,
  isUpdatingStatus: false,
};

const CarePlanTaskReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CARE_PLAN_TASKS:
        draft.isFetchingTasks = true;
        break;
      case FETCH_CARE_PLAN_TASKS_SUCCESS:
        draft.isFetchingTasks = false;
        draft.tasks = action.payload;
        break;
      case FETCH_CARE_PLAN_TASKS_FAILURE:
        draft.isFetchingTasks = false;
        break;
      case ADD_CARE_PLAN_TASK:
      case EDIT_CARE_PLAN_TASK:
        draft.isSubmitting = true;
        break;
      case ADD_CARE_PLAN_TASK_SUCCESS:
      case EDIT_CARE_PLAN_TASK_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_CARE_PLAN_TASK_FAILURE:
      case EDIT_CARE_PLAN_TASK_FAILURE:
        draft.isSubmitting = false;
        break;
      case DELETE_CARE_PLAN_TASK:
        draft.isDeleting = true;
        break;
      case DELETE_CARE_PLAN_TASK_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_CARE_PLAN_TASK_FAILURE:
        draft.isDeleting = false;
        break;
      case FETCH_CARE_PLAN_TASK_TEMPLATES:
        draft.isFetchingTaskTemplates = true;
        break;
      case FETCH_CARE_PLAN_TASK_TEMPLATES_SUCCESS:
        draft.isFetchingTaskTemplates = false;
        draft.taskTemplates = Array.isArray(action.payload?.data)
          ? action.payload.data
          : Array.isArray(action.payload)
            ? action.payload
            : [];
        break;
      case FETCH_CARE_PLAN_TASK_TEMPLATES_FAILURE:
        draft.isFetchingTaskTemplates = false;
        break;
      case MARK_CARE_PLAN_TASK_STATUS:
        draft.isUpdatingStatus = true;
        break;
      case MARK_CARE_PLAN_TASK_STATUS_SUCCESS:
      case MARK_CARE_PLAN_TASK_STATUS_FAILURE:
        draft.isUpdatingStatus = false;
        break;
      default:
        return state;
    }
  });

export default CarePlanTaskReducer;
